export const routes = {
    ROOT: "/",
};
